import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { axiosInstance } from "../client";
import { AgentSession } from "@rumble-it/common-lib/types/models/AgentSession.interface";
import { Message } from "@rumble-it/common-lib/types/models/Message.interface";

export interface DossierAgentSessions {
  id: string;
  agentSessions: AgentSession[];
}

export const sendMessage = async (
  message: string,
  agentId: string,
  sessionId: string | null,
): Promise<any> =>
  axiosInstance.post(
    `/agents/${agentId}/session`,
    { message },
    {
      headers: {
        "X-Session-Id": sessionId,
      },
    },
  );

// TODO: This will be replaced when the API resource on the backend is ready
export const fetchAgentSessionByDossierId = async (
  id: string,
): Promise<DossierAgentSessions> =>
  axiosInstance
    .get(`/admin/dossiers/repair-direct/generic/${id}`)
    .then((response) => response.data);

export const fetchMessagesByAgentSessionId = async (
  id: string,
  agentId: string,
): Promise<CollectionResponse<Message>> =>
  axiosInstance
    .get(`/agents/${agentId}/session/${id}/messages?limit=1000`)
    .then((response) => response.data);
